import { baseUrl } from "../../../../boot";
import axios from "axios";

// Add Shade
export const addShade = async (formData) => {
  console.log("Shade form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}shade/api/v1/createShade`, formData, {
      // headers: {
      //   "auth-token": token,
      // }
      headers: { "Content-Type": "multipart/form-data" }
    },)
    console.log("sahde reqqeqw",response);
    return response;
  } catch (error) {
    throw error
  }
}

// delete Shade  API
export const deleteShade = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}shade/api/v1/deleteShadeById`, {
      data: {
        ids: [ROWID]
      },
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// update Shades
export const updateShade = async (ROWID, data) => {
  console.log({ data })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}shade/api/v1/updateShadeById/${ROWID}`, data, {
      // headers: {
      //   "auth-token": token,
      // }
      headers: { "Content-Type": "multipart/form-data" }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// total count
export const countShade = async (formData) => {
  console.log(formData, "count")
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}shade/api/v1/getCountOfShades`, formData, {
      // headers: {
      //   "auth-token": token,
      // }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

export const getShadeDetailById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}shade/api/v1/getShadeById/${id}`, {
      headers: {
        "auth-token": token,
      }
    })
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response
  } catch (error) {
    throw error
  }
}

// update Shades
export const deleteShadeItemsById = async (ROWID, data) => {
  console.log({ data })
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}shade/api/v1/deleteItemsShadeById/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// get Uniqueshade filter
export const getUniqueShade = async (data) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(
      `${baseUrl}shade/api/v1/searchProductsOrShades`,
      data,
      {
        headers: {
          "auth-token": token,
        },
      }
    );

    return response;
  } catch (error) {
    console.log("Error in getUniqueShade API:", error);
    throw error;
  }
};

export const getShadeByName = async (name) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}shade/api/v1/getShadeByShadeName/${name}`, {
      headers: {
        "auth-token": token,
      }
    })
    return response
  } catch (error) {
    throw error
  }
};

export const addShadeinZohoBooks = async (Id, payload) => {
  console.log("Shade Zoho form data payload ---- ", payload);
  try {
    const response = await axios.post(`${baseUrl}zohoBooks/api/v1/item/${Id}`, payload, {
      headers: {
        "Content-Type": "application/json"
      }
    },)
    console.log("shade zoho books resp",response);
    return response;
  } catch (error) {
    throw error
  }
}